var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SignIn'),_c('notifications',{attrs:{"group":"toast","position":"bottom center","classes":"vue-notification is-size-6 mb-5","max":1,"width":"350"}}),_c('main',[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }